import styled from "styled-components";
import { ButtonBase } from '@mui/material';
import {tokens} from "../../../../theme";

export const FullWidthUpload = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    background: ${({theme}) => theme.palette.background.paper};
    height: 100%;
    width: 100%;
`;

export const DragDropArea = styled(ButtonBase)<{ $isDragging?: boolean }>`
    && {
        flex: 1;
        margin: 16px;
        padding: 32px;
        box-sizing: border-box;
        background: ${({ $isDragging, theme }) => (
            $isDragging 
                ? theme.palette.action.hoveredDropzone 
                    : theme.palette.background.dropzone
        )};
        
        border-radius: 24px;
        border: 2px dashed ${({ $isDragging, theme }) => (
            $isDragging 
                    ? theme.palette.dividers.strong
                    : theme.palette.divider
        )};
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: all 0.2s ease;
        width: calc(100% - 32px);

        &:hover {
            background: ${({ theme }) => theme.palette.action.hoveredDropzone };
            border-color: ${({ theme }) => theme.palette.dividers.strong};
        }
    }
`;

export const MiniUploadWrapper = styled.div`
    width: 100%;
    flex-shrink: 0;
`;

export const MiniDragDropArea = styled(ButtonBase)<{ $isDragging?: boolean }>`
    && {
        width: 100%;
        padding: 24px 16px;
        
        background: ${({ $isDragging, theme }) => (
                $isDragging
                        ? theme.palette.action.hoveredDropzone
                        : theme.palette.background.dropzone
        )};
        border: 2px dashed ${({ $isDragging, theme }) => (
                $isDragging
                        ? theme.palette.dividers.strong
                        : theme.palette.divider
        )};

        border-radius: ${tokens.radius.md};
        
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        
        gap: 8px;
        cursor: pointer;
        transition: all 0.2s ease;

        &:hover {
            background: ${({ theme }) => theme.palette.action.hoveredDropzone };
            border-color: ${({ theme }) => theme.palette.dividers.strong};
        }
    }
`;



export const IconCircle = styled.div`
    width: 64px;
    height: 64px;
    background: ${({ theme }) => theme.palette.background.paper};
    border-radius: 50%;
    border: 1px solid ${({ theme }) => theme.palette.dividers.default};
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 16px;
    
    svg {
        width: 28px;
        height: 28px;
    }
`;

export const MiniIconCircle = styled.div`
    width: 48px;
    height: 48px;
    background: ${({ theme }) => theme.palette.background.paper};
    border-radius: 50%;
    border: 1px solid ${({ theme }) => theme.palette.dividers.default};
    display: flex;
    justify-content: center;
    align-items: center;
    
    svg {
        width: 28px;
        height: 28px;
    }
`;